import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Label, Text } from 'pcln-design-system'

const propTypes = {
  className: PropTypes.string,
  currencySymbol: PropTypes.string,
  minSelected: PropTypes.number.isRequired,
  maxSelected: PropTypes.number.isRequired,
  absMax: PropTypes.number,
  absMin: PropTypes.number,
  plusSymbol: PropTypes.string,
  sliderName: PropTypes.string,
  formatByTime: PropTypes.bool,
  formatByDuration: PropTypes.bool,
  isMilitaryTime: PropTypes.bool,
  separatorText: PropTypes.string,
  separatorPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  postFixText: PropTypes.string,
  postFixPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  utc: PropTypes.bool,
}

const defaultProps = {
  formatByTime: false,
  formatByDuration: false,
  isMilitaryTime: false,
  separatorText: ' to ',
  separatorPadding: 0,
  postFixText: '',
  postFixPadding: 0,
}

const generateAfterLabel = (absMax, maxSelected, plusSymbol, sliderName) => {
  return `${plusSymbol && maxSelected === absMax ? plusSymbol : ''} ${sliderName || ''} `
}

export const format = (number, absMin, absMax, formatByTime, isMilitaryTime, formatByDuration, utc) => {
  if (formatByTime) {
    const momentNumber = utc ? moment.utc(number) : moment(number)
    const meridian = momentNumber.hour() < 12 ? 'a' : 'p'
    return isMilitaryTime ? momentNumber.format(`ddd HH:mm`) : momentNumber.format(`ddd h:mm[${meridian}]`)
  } else if (formatByDuration) {
    const duration = moment.duration(number)
    return `${Math.floor(duration.asHours())}h ${moment.utc(duration.asMilliseconds()).format('m')}m`
  }
  return number
}

const RangeSliderLabel = ({
  className,
  currencySymbol,
  minSelected,
  maxSelected,
  absMax,
  absMin,
  plusSymbol,
  sliderName,
  formatByTime,
  formatByDuration,
  isMilitaryTime,
  separatorText,
  separatorPadding,
  postFixText,
  postFixPadding,
  utc,
}) => {
  return (
    <Label fontSize={0} fontWeight='regular' color='text' className={className}>
      {currencySymbol}
      <Text.span>
        {format(minSelected, absMin, absMax, formatByTime, isMilitaryTime, formatByDuration, utc)}
      </Text.span>
      <Text.span px={separatorPadding}>
        {formatByDuration || separatorText}
        {currencySymbol}
      </Text.span>
      <Text.span>
        {!formatByDuration &&
          format(maxSelected, absMin, absMax, formatByTime, isMilitaryTime, formatByDuration, utc)}
      </Text.span>
      {generateAfterLabel(absMax, maxSelected, plusSymbol, sliderName)}
      {postFixText && <Text.span px={postFixPadding}>{postFixText}</Text.span>}
    </Label>
  )
}

RangeSliderLabel.propTypes = propTypes
RangeSliderLabel.defaultProps = defaultProps
export default RangeSliderLabel
